<template>
  <div class="btn-with-confirmation">
    <button v-if="!isConfirming"
            @click="isConfirming = true"
            class="btn btn-danger"
            :class="{'btn-small': isSmall}"
    ><slot name="button">Do this...</slot></button>

    <p v-else class="confirm-dialog">
      <span :class="{'smallprint': isSmall}"
      >Are you sure?</span>
      <span>
        <button @click="$emit('click')"
                class="btn btn-danger"
                :class="{'btn-small': isSmall}"
        ><slot name="confirm">Yes</slot></button>
        |
        <button @click="isConfirming = false"
                class="btn"
                :class="{'btn-small': isSmall}"
        >No</button>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: "ButtonWithInlineConfirmation",
  props: {
    isSmall: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isConfirming: false,
    }
  }
}
</script>

<style>
.confirm-dialog {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0;
}
</style>